<template>
    <div class="campaign-light__content-header library-header">
        <section-nav />
        <div class="campaign-light__content-header-items">
            <div class="library-header__select-all">
                <Checkbox
                    :disabled="paginatedDeliverables.length === 0 || selectAllDisabled"
                    :indeterminate="isSelectionIndeterminate"
                    :model-value="allPageDeliverablesAreSelected"
                    data-testid="library-header__select-all-checkbox"
                    @click.prevent="toggleDeliverableSelection"
                >
                    Select all
                </Checkbox>

                <span class="library-header__selected-count">{{ numberOfSelectedDeliverables }} Selected</span>
                <span v-if="canDownloadOrPublish" class="library-header__selected-count">
                    <Button icon="ios-cloud-upload-outline" size="small" @click="selectViaFile" />
                </span>
            </div>
            <div class="library-header__buttons">
                <div v-if="isTableView" class="campaign-light__content-header-item">
                    <CustomiseTableColumnsDropdown />
                </div>
                <div class="campaign-light__content-header-item">
                    <RadioGroup :model-value="viewMode" type="button" @onChange="setViewMode">
                        <Radio :label="ViewMode.Grid">
                            <Icon type="md-apps" />
                        </Radio>
                        <Radio :label="ViewMode.Table">
                            <Icon type="md-list" />
                        </Radio>
                    </RadioGroup>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomiseTableColumnsDropdown from "@/components/Campaign/LibraryDeliverableTable/LibraryDeliverableTableCustomiseColumnsDropdown.vue";
import SectionNav from "@/components/SectionNav.vue";
import { ViewMode } from "@/enums/library";

export default {
    name: "LibraryHeader",
    components: {
        CustomiseTableColumnsDropdown,
        SectionNav
    },

    props: {
        allSelectedMode: {
            type: Boolean,
            default: false
        },
        paginatedDeliverables: {
            required: true,
            type: Array
        },
        selectAllDisabled: {
            type: Boolean
        },
        selectedDeliverables: {
            required: true,
            type: Array
        },
        viewMode: {
            required: true,
            type: String
        },
        libraryFiltersForQuery: {
            required: true,
            type: Object
        },
        totalItems: {
            required: true,
            type: Number
        }
    },

    emits: ["viewModeSet", "selectedDeliverablesUpdated", "selectViaFile"],

    computed: {
        allPageDeliverablesAreSelected() {
            return (
                this.hasDeliverablesSelected && this.paginatedDeliverables.length === this.selectedDeliverables.length
            );
        },

        canDownloadOrPublish() {
            return (
                this.$auth.userCan(this.$auth.Actions.CanDownloadDeliverable, {
                    clientId: this.clientId,
                    campaignId: this.campaignId
                }) ||
                this.$auth.userCan(this.$auth.Actions.CanPublishDeliverableToAdServer, {
                    clientId: this.clientId,
                    campaignId: this.campaignId
                })
            );
        },

        campaignId() {
            return this.$route.params.campaignId;
        },

        clientId() {
            return this.$route.params.clientId;
        },

        hasDeliverablesSelected() {
            return this.selectedDeliverables.length > 0;
        },

        isSelectionIndeterminate() {
            return this.hasDeliverablesSelected && !this.allSelectedMode && !this.allPageDeliverablesAreSelected;
        },

        isTableView() {
            return this.viewMode === ViewMode.Table;
        },

        numberOfSelectedDeliverables() {
            if (this.allSelectedMode) {
                return this.totalItems;
            }

            return this.selectedDeliverables.length;
        }
    },

    created() {
        this.ViewMode = ViewMode;
    },

    methods: {
        setViewMode(viewMode) {
            this.$emit("viewModeSet", viewMode);
        },

        toggleDeliverableSelection() {
            if (!this.selectAllDisabled) {
                if (this.allSelectedMode) {
                    this.$emit("selectedDeliverablesUpdated", []);
                } else if (!this.hasDeliverablesSelected || this.isSelectionIndeterminate) {
                    this.$emit(
                        "selectedDeliverablesUpdated",
                        this.paginatedDeliverables.map(({ idHash }) => idHash)
                    );
                } else {
                    this.$emit("selectedDeliverablesUpdated", []);
                }
            }
        },

        selectViaFile() {
            this.$emit("selectViaFile");
        }
    }
};
</script>

<style lang="scss">
@use "@style/variables" as *;

.library-header__buttons {
    align-items: center;
    display: flex;
    height: 100%;
    gap: 5px;
}

.library-header__group {
    align-items: center;
    display: flex;
    border-right: 1px solid $grey3;
    height: 100%;
    margin-right: 16px;
    padding-right: 20px;
}

.library-header__select-all {
    white-space: nowrap;
    margin-right: $spacing;
}

.library-header__selected-count {
    border-left: 1px solid $grey3;
    font-size: $font-size-base;
    padding: 0 0 0 $spacing-small;
}

.campaign-light__content-header-group--buttons {
    button {
        padding: 15px 20px;
    }
}
</style>
